import { Instance, flow, types } from 'mobx-state-tree';

import { getCurator, removeCurator, saveCurator } from '@common/api/curators';
import { deleteMedia } from '@common/api/media';
import User from '@common/models/Users/User';

const Curator = types
	.compose(
		User,
		types.model({
			services_ids: types.optional(types.array(types.number), []),
			locations_ids: types.optional(types.array(types.number), []),
		}),
	)
	.named('Curator')
	.actions(() => ({
		_fetch: getCurator,
		_save: saveCurator,
		_remove: removeCurator,
	}))
	.actions((self) => ({
		deleteAvatar: flow(function* () {
			yield deleteMedia({ id: self.user_id, entity: 'users', media_collection: 'avatar' });
			yield self._fetch(self.id);
		}),
	}));

export default Curator;

export interface ICuratorModel extends Instance<typeof Curator> {}
